import { Box, ContentTemplate, TitleHeader } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';


import { makeStyles } from 'tss-react/mui';
import SpecialConsiderationCoordinatorListingTable from './SpecialConsiderationCoordinatorListingTable';

const useStyles = makeStyles()((theme) =>
({
  dataTable: {
    marginBottom: theme.spacing(7),
  },
}));

const SpecialConsiderationCoordinatorListing = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <>
      <TitleHeader title={t('specialConsideration->>Listing.SpecialConsideration')} />
      <ContentTemplate transparent continuous type="full">
        <Box className={classes.dataTable}>
          <SpecialConsiderationCoordinatorListingTable />
        </Box>
      </ContentTemplate>
    </>
  );
};
export default SpecialConsiderationCoordinatorListing;
